<template>
  <div v-if="showSharing" class="pb-0 mb-2 horizontal layout center">
    <Buttonv2
      size="lg"
      variant="outline-dark"
      @click="fbShareLink()"
      class="flex mr-1 facebook-button"
    >
      <span class="d-sm-none d-md-block">
        <i class="fab fa-facebook-f" />
        {{ $t('Post to {msg}', { msg: 'Facebook' }) }}
      </span>
      <span class="text-base d-none d-sm-block d-md-none">
        <i class="fab fa-facebook-f" />
        Facebook
      </span>
    </Buttonv2>

    <Buttonv2
      size="lg"
      variant="outline-dark"
      class="flex ml-1 twitter-button"
      @click="twShareLink()"
    >
      <span class="d-sm-none d-md-block">
        <i class="fab fa-twitter" />
        {{ $t('Post to {msg}', { msg: 'Twitter' }) }}
      </span>
      <span class="text-base d-none d-sm-block d-md-none">
        <i class="fab fa-twitter" />
        Twitter
      </span>
    </Buttonv2>
  </div>
</template>

<script>
import Config from '@/config'
import Util from '@/util'
import Buttonv2 from '@/components/UI/Buttonv2.vue'

export default {
  components: {
    Buttonv2,
  },
  props: {
    position: Number,
    total: Number,
    isTeam: Boolean,
  },
  data() {
    return {
      showSharing: false,
    }
  },
  mounted() {
    if (window.location.host === Config.domain) {
      this.showSharing = true
    }
  },
  methods: {
    buildUrl(url, params) {
      const query = Object.entries(params)
        .map((pair) => pair.map(encodeURIComponent).join('='))
        .join('&')
      return `${url}${query ? `?${query}` : ''}`
    },
    getShareLink(source) {
      const presentationId = this.$store.state.presentation.id
      const shareRoot = `${Config.baseUrl}/p/quiz/${this.isTeam ? 'team-' : ''}${this.position}-of-${this.total}`

      const utmData = {
        utm_campaign: 'share_quiz_result',
        utm_medium: 'share',
        utm_source: source,
        utm_content: `quiz_result_presentation_${presentationId}`,
        lang: this.$store.state.presentation.language || 'en',
      }

      // en is default
      if (utmData.lang === 'en') {
        delete utmData.lang
      }

      return encodeURIComponent(this.buildUrl(shareRoot, utmData))
    },
    fbShareLink() {
      const presentationId = this.$store.state.presentation.id
      const href = this.getShareLink('facebook')
      const redirectUri = encodeURIComponent('https://www.facebook.com')
      const appId = 938819863278189

      Util.gaTrackEvent(
        'Audience Quiz',
        'Share quiz result to Facebook',
        `Share quiz result to Facebook for presentation ${presentationId}`,
      )

      const link = `https://www.facebook.com/dialog/share?app_id=${appId}&display=popup&href=${href}&redirect_uri=${redirectUri}`
      window.open(link, '_blank')
    },
    twShareLink() {
      const presentationId = this.$store.state.presentation.id
      const href = this.getShareLink('twitter')
      const sharingText = this.$t('I just finished a super fun quiz on AhaSlides')
      const text = encodeURIComponent(`${sharingText.replace(' AhaSlides', ' @AhaSlides')} #ahaslides`)

      Util.gaTrackEvent(
        'Audience Quiz',
        'Share quiz result to Twitter',
        `Share quiz result to Twitter for presentation ${presentationId}`,
      )

      const link = `https://twitter.com/intent/tweet?text=${text}&url=${href}`
      window.open(link, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
$facebook-color: #2A5297;
$twitter-color: #55ADED;
.ui-button--block {
  height: 42px;
  padding: 0 16px;
  border-radius: 20px;
}

.fa-twitter {
  color: $twitter-color;
  margin-right: 2px;
  transition: color 0.3s ease-in-out;
}

.fa-facebook-f {
  color: $facebook-color;
  margin-right: 2px;
  transition: color 0.3s ease-in-out;
}

.facebook-button {
  &:hover, &:active, &:focus {
    background: $facebook-color;
    color: #fff;
    .fa-facebook-f {
      color: #fff;
    }
  }
}

.twitter-button {
  &:hover, &:active, &:focus {
    background: $twitter-color;
    color: #fff;
    .fa-twitter {
      color: #fff;
    }
  }
}
@media (max-width: 350px) {
  .text-base {
    font-size: 14px;
  }
}
</style>
